import React, { useState, useEffect } from "react";
import { IntroTitle } from "../../components/IntroTitle/IntroTitle";
import { LinkText } from "../../components/LinkText/LinkText";
import { Card } from "../../components/Card/Card";
import { Recap } from "../../components/Recap/Recap";
import { InfoTrasparenti } from "../../components/InfoTrasparenti/InfoTrasparenti";
import { PageTemplate } from "../../templates/PageTemplate/PageTemplate";
import { useNavigate } from "react-router-dom";
import { routePath } from "../../helpers/Pipes";
import { formatCurrency, formatPercentage } from "../../helpers/Pipes";
import { Simulation } from "../../hooks/simulationData";
import parse from "html-react-parser";
import { useDynatrace } from "../../hooks/useDynatrace";

export const Page = ({ linkUrl, linkUrlButton, onNextRoute, onRedoSimulationClick }) => {
    const navigate = useNavigate();
    const [isModalActive, setIsModalActive] = useState(false);
    const [r, setR] = useState("");

    const {} = useDynatrace();

    const handleManageModalActive = () => {
        setIsModalActive(!isModalActive);
    };

    useEffect(() => {
        // check localstorage for default simulation
        if (!window.hasRoot) {
            if (sessionStorage.getItem("outerSimulation")) {
                try {
                    const defaultSimulation = JSON.parse(sessionStorage.getItem("outerSimulation"));
                    Simulation.merge({
                        importo: defaultSimulation.amount.current,
                        rataValue: defaultSimulation.payment.current,
                        minTAEG: defaultSimulation.TAEG.min,
                        maxTAEG: defaultSimulation.TAEG.max,
                        minTAN: defaultSimulation.TAN.min,
                        maxTAN: defaultSimulation.TAN.max,
                        minImporto: defaultSimulation.amount.min,
                        maxImporto: defaultSimulation.amount.max,
                        minRata: defaultSimulation.payment.min,
                        maxRata: defaultSimulation.payment.max,
                        minDurata: defaultSimulation.numberOfInstallments.min,
                        maxDurata: defaultSimulation.numberOfInstallments.max,
                        purposeSelectValue: {
                            label: defaultSimulation.purpose.text,
                            value: defaultSimulation.purpose.code,
                            image: "spese-familiari",
                        },
                        purpose: defaultSimulation.purpose.code,
                        purposeIconName: "spese-familiari",
                        purposeCode: defaultSimulation.purpose.index,
                        purposeTitle: defaultSimulation.purpose.text,
                        oneriTrasparenza: defaultSimulation.others.transparencyDuty,
                        maxIstruttoria: defaultSimulation.others.maxComm,
                        minIstruttoria: defaultSimulation.others.administrationFees,
                        minOneri: defaultSimulation.others.stampDuty,
                        maxOneri: defaultSimulation.others.maxImpBollo,
                    });
                    window.hasRoot = true;
                    setR(" ");
                } catch (error) {
                    navigate(routePath("simulatore"));
                }
            } else {
                navigate(routePath("simulatore"));
            }
        } 
        // else {
        //     console.log(Simulation.get());
        // }
    }, []);

    useEffect(() => {
        window.dataLayer.push({
            event: "customPageview",
            fase_ds: "0 - simulatore",
            prestito: {
                importoRichiesto: `${Simulation.get("importo")}`,
                importoRata: `${Simulation.get("minRata")}/${Simulation.get("maxRata")}`,
                numeroRate: `${Simulation.get("minDurata")}/${Simulation.get("maxDurata")}`,
                obiettivo: Simulation.get("purposeTitle"),
            },
        });
    }, []);

    return (
        <PageTemplate customClasses="--bg-yellow mobile-no-btn-fixed" headerCustomClasses="" modal={true} modalId="pre">
            <main>
                <div className="container --small">
                    <IntroTitle projectName={Simulation.get("purposeTitle")} titleSelect="second" customClasses="mBottom6x" />
                    {r}
                </div>

                <div className="container --medium">
                    <Recap
                        type="money-recap"
                        label="online"
                        labelIcon="star"
                        url={Simulation.get("purposeIconName")}
                        title="come realizziamo il tuo sogno?"
                        description={parse(
                            `Con <span>${formatCurrency(Simulation.get("importo"), false)}</span> e una rata di <span>${formatCurrency(Simulation.get("rataValue"), false)}/mese</span>.`
                        )}
                        details="dettagli"
                        labelShow="no"
                        rateNumb="Numero rate:"
                        rate={
                            Simulation.get("minDurata") != Simulation.get("maxDurata")
                                ? parse(`da <strong>${Simulation.get("minDurata")}</strong> a <strong>${Simulation.get("maxDurata")}</strong>`)
                                : parse(`<strong>${Simulation.get("maxDurata")}</strong>`)
                        }
                        tan="TAN:"
                        tanValue={
                            Simulation.get("minTAN") != Simulation.get("maxTAN")
                                ? parse(`da <strong>${formatPercentage(Simulation.get("minTAN"))}</strong> a <strong>${formatPercentage(Simulation.get("maxTAN"))}</strong>`)
                                : parse(`<strong>${formatPercentage(Simulation.get("maxTAN"))}</strong>`)
                        }
                        taeg="TAEG:"
                        taegValue={
                            Simulation.get("minTAEG") != Simulation.get("maxTAEG")
                                ? parse(`da <strong>${formatPercentage(Simulation.get("minTAEG"))}</strong> a <strong>${formatPercentage(Simulation.get("maxTAEG"))}</strong>`)
                                : parse(`<strong>${formatPercentage(Simulation.get("maxTAEG"))}</strong>`)
                        }
                        customClasses="mBottom6x"
                        linkCustomClasses="mBottom4x"
                        buttonLabel="Continua"
                        buttonIcon="arrow-right"
                        modalRecapOnClick={handleManageModalActive}
                        linkUrlButton={linkUrlButton}
                        buttonRecapOnClick={() => {
                            onNextRoute({});
                        }}
                    />
                </div>

                <div className="container --small">
                    <LinkText type="link-only" linkText="Vorrei modificare la simulazione" customClasses="mBottom6x" linkUrl={linkUrl} onClick={onRedoSimulationClick} />

                    <InfoTrasparenti containerSize="--small" separatorContainerSize="--small" />

                    <Card
                        type="card-pills"
                        iconName="voice"
                        title="Lo sapevi che"
                        customClasses="mBottom6x"
                        description={parse(
                            "I valori dei tassi (TAN e TAEG) rimarranno espressi come intervallo tra minimo e massimo, finchè non avremo preso in carico e valutato la tua richiesta.<br>Per personalizzare la tua richiesta di prestito ti chiediamo quindi di fornirci maggiori informazioni."
                        )}
                    />
                </div>
            </main>
        </PageTemplate>
    );
};
